export default class Scroll {
  constructor() {
    this.scrollable = document.querySelector('div[data-scroll')
    this.current = 0
    this.target = 0
    this.ease = 1
    this.init()
    this.smoothScroll()
  }
  lerp(start, end, t) {
    return start * (1 - t) + end * t
  }
  init() {
    document.body.style.height = `${this.scrollable.getBoundingClientRect().height}px`
  }
  smoothScroll() {
    this.target = window.scrollY
    this.current = this.lerp(this.current, this.target, this.ease)
    this.scrollable.style.transform = `translate3D(0, -${this.current}px, 0)`
    window.requestAnimationFrame(this.smoothScroll.bind(this))
  }
  update() {
    this.scrollable.update()
  }
}
